import * as serviceContext from './serviceContext';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function addCurrency(currencyData) {
    try {
        const response = await serviceContext.post("affiliate/currency", JSON.stringify(currencyData), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getCurrency() {
    try {
        const response = await serviceContext.get("admin/currency", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};



export async function getCurrencyList() {
    try {
        const response = await serviceContext.get("affiliate/currency", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};